export const reglas = [
  {
  id: 1,
  visible: true,
  },
  {
  id: 2,
  visible: true,
  },
  {
  id: 3,
  visible: true,
  },
  // {
  // id: 4,
  // visible: true,
  // },
  // {
  // id: 5,
  // visible: true,
  // },
];
